import { createActionsHook } from 'src/lib/sweetState';

import { type Actions, AdvancedStore, type State } from './AdvancedStore';

export const useAdvancedActions = createActionsHook<State, Actions>(AdvancedStore);
